import type { StatusDelivery } from '@/Interfaces/Data';
import { STATUS_ENTREGA } from '@/Constants';
import {
  DELIVERYMAN_GOING_TO_STORE_ICON,
  DELIVERYMAN_IN_DELIVERY_ICON,
  IN_DELIVERY_RUN_STATUSES,
} from './constants';
import type { MapPosition } from './types';

export const isDeliverymanInDeliveryRun = (status: StatusDelivery) =>
  IN_DELIVERY_RUN_STATUSES.includes(status);

export const getDeliverymanPointerIcon = (status: StatusDelivery) =>
  isDeliverymanInDeliveryRun(status)
    ? DELIVERYMAN_IN_DELIVERY_ICON
    : DELIVERYMAN_GOING_TO_STORE_ICON;

export const isSameMapPosition = (origin: MapPosition, target: MapPosition) =>
  origin[0] === target[0] && origin[1] === target[1];

export const getDeliverymanRouteTarget = (
  status: StatusDelivery,
  placeLocation: MapPosition,
  deliveryLocation: MapPosition,
): MapPosition | null => {
  if (status === STATUS_ENTREGA.CHEGOU_NA_LOJA) {
    return null;
  }

  return isDeliverymanInDeliveryRun(status) ? deliveryLocation : placeLocation;
};

export const getUniquePositions = (positions: MapPosition[]) => {
  const seen = new Set<string>();

  return positions.filter(([latitude, longitude]) => {
    const key = `${latitude},${longitude}`;

    if (seen.has(key)) {
      return false;
    }

    seen.add(key);
    return true;
  });
};
